export enum ClientStatus {
  ACTIVE = 'Actieve',
  INACTIVE = 'Inactieve',
  ACTIVE_AND_INACTIVE = 'Actieve & inactieve',
}
